export const config = {
    highlights: [
        "cover-style.jpeg",
        "frango.jpeg",
        "inside-0.jpeg",
        "couvert-1.jpeg",
        "frango-2.jpeg",
        "inside-1.jpeg"
    ],
    contact: {
        address: {
            display: "Alfredo dos Frangos \nRua General Humberto Delgado nº9 \n8200-447 Guia, Albufeira",
            url: "https://www.google.com/maps?q=Alfredo+dos+Frangos,+Guia,Albufeira&output=embed"
        },
        phone: {
            display: "+351 939 451 440", 
            url: "tel:+351939451440"},
        instagram: {
            display: "alfredo_dos_frangos",
            url: "https://www.instagram.com/alfredo_dos_frangos/"
        },
        google: {
            display: "Alfredo dos Frangos",
            url: "https://g.co/kgs/52yGoYr"
        }
    }
}